import makeStyles from '@material-ui/styles/makeStyles';

export default makeStyles({
  videoPlayer: {
    '& > video': {
      height: 'auto !important',
    },
  },
});
